export const removeItemFromArrayByIndex = (indexToRemove: number, array: any[] = []) => {
  return array.filter((_, id) => id !== indexToRemove);
};
